import React, { Suspense } from "react";
import styles from "./LoadingBoundary.module.css";

interface LoadingBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const DefaultLoading = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.spinner}>
      <div className={styles.spinnerOuter}></div>
      <div className={styles.spinnerInner}></div>
      <div className={styles.spinnerCore}></div>
      <div className={styles.loadingText}>Cargando...</div>
    </div>
  </div>
);

export const LoadingBoundary: React.FC<LoadingBoundaryProps> = ({
  children,
  fallback = <DefaultLoading />,
}) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};
